<template>
	<div>
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>系统管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>资源管理</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<el-row :gutter="20">
				<!-- 	<el-col :span="7">
					<el-input placeholder="请输入内容" v-model="authoritie.searchValue">
						<el-button slot="append" icon="el-icon-search" @click="getauthoritieList()"></el-button>
					</el-input>
				</el-col> -->
				<el-col :span="12">
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addAuthorityInit()">+ 添加权限</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="changeIsExpand()">全部展开/折叠</el-button>
				</el-col>
			</el-row>
			<!-- 权限列表区 树形表格 -->
			<el-table v-if="refreshTable" :data="authoritieList" style="width: 100%;margin-bottom: 20px;" row-key="authorityId" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}"
			 border :default-expand-all="isExpand" :tree-props="{children: 'childList'}" :stripe="true" :highlight-current-row="true">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="authorityId" label="ID" sortable>
				</el-table-column>
				<el-table-column prop="authorityName" label="资源名称" sortable>
				</el-table-column>
				<el-table-column prop="isMenu" header-align="center" align="center" label="菜单">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.isMenu === 0" type="success" size="small">菜单</el-tag>
						<el-tag v-else-if="scope.row.isMenu === 1" size="small" type="info">按钮</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="menuIcon" label="图标">
				</el-table-column>
				<el-table-column prop="menuUrl" label="按钮地址">
				</el-table-column>
				<el-table-column prop="authority" label="权限标识">
				</el-table-column>
				<el-table-column prop="orderNumber" label="排序号">
				</el-table-column>
				<el-table-column prop="parentId" label="父级id">
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="150" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" style="background-color: #3CA757;color: #FFFFFF;" icon="el-icon-edit" @click="updateAuthorityInit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteAuthority(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 添加权限 -->
			<el-dialog title="添加权限" :visible.sync="addAuthorityDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="authority" style="margin-right: 1.50rem;" status-icon :rules="authorityRules" ref="authority"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="父级菜单" prop="parentId">
						<el-select style="width: 100%;" :clearable=true v-model="authority.parentId" :filterable=true size="small"
						 placeholder="请选择上级菜单">
							<el-option v-for="item in menus" :key="item.authorityId" :label="item.authorityName" :value="item.authorityId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="权限名称" prop="authorityName">
						<el-input placeholder="请输入权限名称" v-model="authority.authorityName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单地址" prop="menuUrl">
						<el-input placeholder="请输入菜单地址" v-model="authority.menuUrl" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="权限标识" prop="authority">
						<el-input placeholder="请选输入权限标识" v-model="authority.authority" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单" prop="isMenu">
						<el-radio-group v-model="authority.isMenu">
							<el-radio v-model="authority.isMenu" label='0'>菜单</el-radio>
							<el-radio v-model="authority.isMenu" label='1'>按钮</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="菜单图标" prop="menuIcon">
						<el-input placeholder="请输入菜单图标" v-model="authority.menuIcon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNumber">
						<el-input placeholder="请输入排序号" v-model="authority.orderNumber" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addAuthorityDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addAuthority()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 权限修改 -->
			<el-dialog title="权限修改" :visible.sync="updateAuthorityDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="authority" style="margin-right: 1.50rem;" status-icon :rules="authorityRules" ref="authority"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="父级菜单" prop="parentId">
						<el-select style="width: 100%;" :clearable=true v-model="authority.parentId" :filterable=true size="small"
						 placeholder="请选择上级菜单">
							<el-option v-for="item in menus" :key="item.authorityId" :label="item.authorityName" :value="item.authorityId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="权限名称" prop="authorityName">
						<el-input placeholder="请输入权限名称" v-model="authority.authorityName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单地址" prop="menuUrl">
						<el-input placeholder="请输入菜单地址" v-model="authority.menuUrl" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="权限标识" prop="authority">
						<el-input placeholder="请选输入权限标识" v-model="authority.authority" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="菜单" prop="isMenu">
						<el-radio-group v-model="authority.isMenu">
							<el-radio v-model="authority.isMenu" :label='0'>菜单</el-radio>
							<el-radio v-model="authority.isMenu" :label='1'>按钮</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="菜单图标" prop="menuIcon">
						<el-input placeholder="请输入菜单图标" v-model="authority.menuIcon" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="排序号" prop="orderNumber">
						<el-input placeholder="请输入排序号" v-model="authority.orderNumber" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateAuthorityDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateAuthority()">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				refreshTable: true,
				isExpand: true,
				authority: {

				},
				menus: [],
				authoritieList: [],
				//控制添加用户信息对话框显示与隐藏
				addAuthorityDialogVisible: false,
				updateAuthorityDialogVisible: false,
				authorityRules: {
					//验证是否合法
					authorityName: [{
							required: true,
							message: '请输权限名称',
							trigger: 'blur',
						},
						{
							min: 2,
							max: 60,
							message: '长度在 2 到 60 个字符',
							trigger: 'blur',
						}
					],
					orderNumber: [{
							required: true,
							message: '请输排序号',
							trigger: 'blur',
						},
						{
							min: 1,
							max: 60,
							message: '长度在 1 到 60 个字符',
							trigger: 'blur',
						}
					],
					isMenu: [{
						required: true,
						message: '请选择是菜单还是按钮',
						trigger: 'blur',
					}],
				}
			}
		},
		created() {
			this.getauthoritieList()
			this.getMenus()
		},
		methods: {
			async getauthoritieList() {
				const {
					data: res
				} = await this.$http.post(
					'/system/authorities/list',
					this.authoritieReq)
				console.log(res)
				if (res.code != 200) return this.$message.error(res.msg)
				this.authoritieList = res.data
			},
			getMenus() {
				this.$http.get('/system/authorities/getMenus').then(res => {
					console.log("选择框菜单列表", res)
					this.menus = res.data.data
				})
			},
			addAuthorityInit() {
				this.addAuthorityDialogVisible = true
				this.authority = {}
			},
			addAuthority() {
				console.log(this.authority)
				this.$http.post('/system/authorities/add', this.authority).then(res => {
					console.log('添加结果', res)
					if (res.data.code == 200) {
						this.addAuthorityDialogVisible = false
						this.getauthoritieList()
						this.getMenus()
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			getAuthority(authorityId) {
				console.log(authorityId)

			},
			deleteAuthority(row) {
				console.log(row)
				this.$confirm("确认删除该条数据吗？", {
					title: "提示",
					type: 'warning',
				}).then(resc => {
					this.$http.post('/system/authorities/delete', {
						'authorityId': row.authorityId
					}).then(res => {
						if (res.data.code == 200) {
							this.getauthoritieList()
							this.getMenus()
							this.$message.success(res.data.msg)
						} else {
							this.$message.error(res.data.msg)
						}
					})
				})
			},
			updateAuthorityInit(row) {
				this.$http.post('/system/authorities/getById', {
					'authorityId': row.authorityId
				}).then(res => {
					if (res.data.code == 200) {
						this.authority = res.data.data
						console.log('authority', res)
					} else {
						this.$message.error(res.data.msg)
					}
				})
				this.updateAuthorityDialogVisible = true
			},
			updateAuthority() {
				this.$http.post('/system/authorities/update', this.authority).then(res => {
					if (res.data.code == 200) {
						this.getauthoritieList()
						this.getMenus()
						this.updateAuthorityDialogVisible = false
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			changeIsExpand() {
				this.refreshTable = false;
				this.isExpand = !this.isExpand;
				this.$nextTick(() => {
					this.refreshTable = true;
				});
			}
		},
	}
</script>

<style>
	.el-radio__input.is-checked+.el-radio__label {
		color: #3CA757 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #3CA757 !important;
		background: #3CA757 !important;
	}
</style>
